<!-- 本科-个人信息页-支付信息 -->
<template>
  <div class='personal-detail-wrap'>
    <div class='detail-container'>
      <div class='personal-detail en'>
        <h4>Payment</h4>
        <ul>
          <li>
            <span class='personal-detail-name'>Chinese Citizen：</span>
            <span class='personal-detail-val'>{{payment.chineseCitizen === 1 ? 'YES' : 'NO'}}</span>
          </li>
          <li>
            <span class='personal-detail-name'>Payment method：</span>
            <span class='personal-detail-val'>{{ payment.payWay | payMethod }}</span>
          </li>
          <li>
            <span class='personal-detail-name'>Account Currency：</span>
            <span class='personal-detail-val'>{{ payment.currency }}</span>
          </li>
          <li>
            <span class='personal-detail-name'>PayPal：</span>
            <span class='personal-detail-val'>{{ payment.payPalEmail }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getUgdPaymentinfo } from '@/api/talents'
import './personal-detail.less'
export default {
  name: '',
  components: {},
  filters: {
    payMethod (value) {
      const map = {
        PAYPAL: { label: 'PAYPAL' },
        INLAND: { label: '云帐户' }
      }
      return map[value] ? map[value].label : ''
    }
  },
  data () {
    return {
      payment: {}
    }
  },
  computed: {},
  mounted () {
    this.getPayment()
  },
  methods: {
    getPayment () {
      getUgdPaymentinfo({}).then(res => {
        this.payment = res.data.paymentInfo.paymentInfo
      }).catch(error => {
        this.$ugd_message(error.message, 'error')
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
